import * as React from 'react'
import { BasePage } from 'app/shared/components/base/BasePage'
import etcimg01 from 'assets/images/etc/service-end-img.png'
import etcimg02 from 'assets/images/etc/ibk-logo.png'
import useBasePage from 'app/shared/hooks/base-page.hook'
import { noTiList } from 'app/core/models/api/com/com0102'
import {
    getStringOfWeek,
    isEmpty,
    replaceTextToHtmlTag,
    setFormatTime,
} from 'app/shared/utils/comUtil'
import moment from 'moment'
import DOMPurify from 'dompurify'
/*======================================================================
 * @ 업무설명 : 종료 안내
 * @ 파 일 명 : /pages/mai/not/MAINOT0102.tsx
 * @Rest URI :
 * @ASIS :
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     김상돈(A03521)   2025.11.07    최초작성
 *======================================================================
 */
const TempNotice: React.FC = () => {
    return (
        <BasePage
            header={false}
            prev={false}
            className="service-end center pt-0"
        >
            <img src={etcimg01} className="service-img mt-64" alt="" />
            <p className="h4 bold mt-16">서비스 점검 안내</p>
            <p className="service-text mt-08">
                <div
                    dangerouslySetInnerHTML={{
                        __html: `IBK기업은행을 이용해주시는<br>고객 여러분께 안내 말씀드립니다.<br>시스템 업그레이드 작업으로 인하여<br>서비스가 일시적으로 중단되오니<br>이용에 양해 부탁드립니다.<br>`,
                    }}
                ></div>
            </p>

            <img src={etcimg02} className="ibk-logo" alt="IBK 기업은행 로고" />
        </BasePage>
    )
}

export default TempNotice
